export default __webpack_public_path__ + "static/media/Imagen1.25759062.svg";